.root {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 0.8em;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-right: 8px;
}

.input {
  color: var(--tuna-palette-grey-500);
  font-size: 13px;
  white-space: nowrap;
}
